import PenerimaanIndex from "@/components/addcost/penerimaan/penerimaanIndex.vue";
import PenerimaanAddCostDetail from "@/components/addcost/penerimaan/penerimaanDetail.vue";


let routesPenerimaan = [

  {
      path: '', // child default
      name: "penerimaanIndex",
      component: PenerimaanIndex
  },

   {
      path: 'detail/:id', // child default
      name: "penerimaanAddCostDetail",
      component: PenerimaanAddCostDetail
    },
    //  {
    //   path: 'edit/:id', // child default
    //   name: "penerimaanAddCostEdit",
    //   component: PenerimaanAddCostEdit
    // },
    
 
];

export default routesPenerimaan;